import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { HeroSectionNew } from "@/components/home/HeroSectionNew";
import { PartnersSectionNew } from "@/components/home/PartnersSectionNew";
import { SolutionsBentoHome } from "@/components/home/SolutionsBentoHome";
import { FeaturesSectionNew } from "@/components/home/FeaturesSectionNew";
import { CPOShowcaseSection } from "@/components/home/CPOShowcaseSection";
import { ProcessSectionNew } from "@/components/home/ProcessSectionNew";
import { CTASectionNew } from "@/components/home/CTASectionNew";
import { SEO, homePageSchema } from "@/components/SEO";

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <SEO
        title="EV Charging Platform - Fast Charging & Fleet Solutions"
        description="Deploy DC Fast Charging up to Megawatt, V2G, Fleet & Smart Charging. NEVI compliant, FedRAMP authorized."
        keywords="EV charging, fast charging, V2G, fleet charging, smart charging, OCPP, NEVI, CPO"
        canonicalUrl="/"
        structuredData={homePageSchema}
      />
      <Navbar />
      <HeroSectionNew />
      <PartnersSectionNew />
      <SolutionsBentoHome />
      <FeaturesSectionNew />
      <CPOShowcaseSection />
      <ProcessSectionNew />
      <CTASectionNew />
      <Footer />
    </main>
  );
};

export default Index;
